import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@redux/reducers/rootReducer';

const requirementsState = (state: RootState) => state.insights.requirements;

const getState = createSelector(requirementsState, (state) => state);

export const insightsRequirementsSelectors = {
  getState,
};
